import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Avatar, Typography } from 'shared/ui'
import { SendFrom } from 'widgets/SendFrom'
import { useSectionMessagesContext } from 'pages/conversations/pages/search/pages/profile/ui/SectionMessages/context/sectionMessagesContext'
import styles from './styles.module.scss'

export const HeaderNewConversation = observer(() => {
  const store = useSectionMessagesContext()
  const {
    contact,
    sendFromStore,
    debounceSendEventChangeInbox,
    loadMessages,
    setInitializedSendFrom,
  } = store

  useEffect(() => {
    if (sendFromStore.loading) return
    if (!sendFromStore.inbox_id) {
      debounceSendEventChangeInbox()

      return
    }

    debounceSendEventChangeInbox()
    loadMessages()
  }, [sendFromStore.inbox_id, sendFromStore.loading])

  useEffect(() => {
    return () => {
      setInitializedSendFrom(false)
    }
  }, [])

  return (
    <div className={styles.wrap}>
      <div className={styles.box}>
        <Typography
          tag={'div'}
          variant={'body-md-regular'}
          className={styles.label}
          ariaLabel={'From'}
        >
          To:
        </Typography>
        <div className={styles.content}>
          <div className={styles.blockContact}>
            <Avatar info={contact.avatarInfo} size={16} fontSize={10} />
            <Typography
              variant={'body-md-regular'}
              className={styles.blockContact__label}
              ariaLabel={'From'}
            >
              {contact.name}
            </Typography>
          </div>
        </div>
      </div>
      <div className={styles.box}>
        <Typography
          tag={'div'}
          variant={'body-md-regular'}
          className={styles.label}
          ariaLabel={'From'}
        >
          From:
        </Typography>
        <div className={styles.content}>
          <SendFrom store={store.sendFromStore} triggerVariant={'button'} tabIndex={0} />
        </div>
      </div>
    </div>
  )
})
